import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";

export const viewAssigneeData = (data) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.maintenance.viewAssigneeData
    ); 
    if (res?.data?.response?.status === true) {
        return true;
    } else {
        return false;
    }
}